import { buildSkillStep } from "@/core/skillForms/builder";

export const hearingsScriptSkillStep3 = buildSkillStep({
  title: "Informações adicionais",
  fields: [
    {
      name: "case_breakdown",
      type: "string",
      ui: {
        label: "Adicione informações adicionais (indicação de elementos de relevância das testemunhas para o caso):",
        placeholder:
          "Exemplo: João é testemunha ocular, tendo presenciado todos os acontecimentos; Maria é vizinha de Carlos e conhece toda a rotina do autor e de sua família; Daniel é colega de trabalho de Carlos e conhece o temperamento dele.",
        widget: "textarea",
      },
    },
  ],
  submitButtonText: "Elaborar roteiro",
});
